<template>
  <section id="noticias" class="secciones seccion-blanca text-center">
    <div class="container">
      <h1>
        <strong>Guía rápida para el usuario</strong>
      </h1>
      <p>Información importante a solo un click.</p>
      <div class="container padding-100">
        <div class="row">
          <div
            v-for="item in guiamodulo"
            :key="item.id_guia_modulo"
            class="col-xl-3 col-lg-4 col-sm-6"
          >
            <router-link
              :to="`/guia/${item.id_guia_modulo - 1}`"
              class="card-guia"
            >
              <div
                class="icon-guia"
                :style="{
                  '--icon-url': `url(${getIcon(item.image_guia_modulo)})`,
                }"
              ></div>

              <div class="text-guia">
                <h3 class="letras-guia">{{ item.title_guia_modulo }}</h3>
                <p v-html="item.desc_guia_modulo"></p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { getGuiaModuloInfo } from '@/service/guia_modulo.service.js';
import { config_settings } from '@/config.js';
export default {
  name: 'GuideModule',
  data() {
    return {
      guiamodulo: [],
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
  methods: {
    getGuiModuloData() {
      getGuiaModuloInfo()
        .then(response => {
          console.log('📌 Datos recibidos desde el backend:', response.data);
          this.guiamodulo = response.data;
        })
        .catch(error => {});
    },

    getIcon(filename) {
      if (!filename) return '';

      return this.imgPreUrl + filename + '.jpg';
    },
  },
  created() {
    this.getGuiModuloData();
    this.getIcon();
  },
};
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

#cotizacion {
  padding: 0px;
}

.padding-100 {
  padding: 50px 0;
}
a.card-guia {
  position: relative;
  top: 0;
  display: flex;
  padding: 15px;
  margin: 0 0 30px 0;
  height: 170px;
  background: rgb(223, 230, 234);
  color: rgb(0, 123, 255);
  border-radius: 10px;
  transition: all 0.35s;
  cursor: pointer;
}
a.card-guia:hover,
a.card-guia:focus,
a.card-guia:active {
  text-decoration: none;
  background: var(--primary-color);
  color: rgb(0, 86, 179);
  box-shadow: 0 10px 30px rgba(123, 142, 152, 0.5);
  top: -2px;
}
.icon-guia {
  display: flex;
  flex-direction: column;
  width: 25%;
}
.icon-guia i {
  margin: 40px auto 0 auto;
  font-size: 50px;
}
.icon-guia span {
  margin: 40px auto 0 auto;
  font-size: 50px;
}
.text-guia {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 15px;
  width: 75%;
  overflow-y: auto;
}
.text-guia h3 {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 900;
}
.text-guia p {
  color: rgb(0, 123, 255);
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 0 0 !important;
}

.letras-guia {
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
